import { render, staticRenderFns } from "./leadStatus.vue?vue&type=template&id=6413e632"
import script from "./leadStatus.vue?vue&type=script&lang=js"
export * from "./leadStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports